<div [class.has-error]="showError">
  <ng-template #fieldComponent />
  @if (showValidationIcons()) {
  <ish-validation-icons
    [field]="field"
    [showError]="showError"
    [ngClass]="{
      'validation-ng-select': field.type === 'custom-select-field',
      'validation-offset': field.type === 'ish-select-field',
      'd-none': field.type === 'ish-captcha-field' || field.type === 'ish-number-field',
      'validation-offset-date-picker': field.type === 'ish-date-picker-field'
    }"
  />
  } @if (showError) {
  <ng-container class="invalid-feedback d-block">
    <ish-validation-message [field]="field" class="validation-message" />
  </ng-container>
  }
</div>
